var _regeneratorRuntime = require("/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/viraj/Documents/market/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BaseFilter = require('./base-filter'); // tracks all results ever recorded


var BaseFilterWithHistory = /*#__PURE__*/function (_BaseFilter) {
  "use strict";

  _inherits(BaseFilterWithHistory, _BaseFilter);

  var _super = _createSuper(BaseFilterWithHistory);

  function BaseFilterWithHistory() {
    var _this;

    _classCallCheck(this, BaseFilterWithHistory);

    _this = _super.call(this);
    _this.allResults = [];
    return _this;
  }

  _createClass(BaseFilterWithHistory, [{
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('BaseFilterWithHistory - no update method specified');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "addResults",
    value: function addResults(newResults) {
      this.allResults = this.allResults.concat(newResults);

      _get(_getPrototypeOf(BaseFilterWithHistory.prototype), "addResults", this).call(this, newResults);
    }
  }, {
    key: "addInitialResults",
    value: function addInitialResults(newResults) {
      this.allResults = this.allResults.concat(newResults);

      _get(_getPrototypeOf(BaseFilterWithHistory.prototype), "addInitialResults", this).call(this, newResults);
    }
  }, {
    key: "getAllResults",
    value: function getAllResults() {
      return this.allResults;
    }
  }]);

  return BaseFilterWithHistory;
}(BaseFilter);

module.exports = BaseFilterWithHistory;